import { NotificationDetail } from '@aibees/shared/features/notifications/components/notification-detail';
import { notificationBadgeInfoMap } from '@aibees/shared/features/notifications/config';
import { LinearProgress } from '@mui/material';
import { forwardRef } from 'react';
import * as Styled from './styles';
import { ProgressSnackbarContentProps } from './types';

/**
 * Shared UI component for progress snackbars.
 * Used by both ControlledProgressSnackbar and TimerProgressSnackbar.
 */
export const ProgressSnackbarContent = forwardRef<
  HTMLDivElement,
  ProgressSnackbarContentProps
>(
  (
    {
      id,
      title,
      icon,
      message,
      progressValue,
      onMouseEnter,
      onMouseLeave,
      className,
      ...other
    },
    ref
  ) => {
    return (
      <Styled.Wrapper
        ref={ref}
        className={className || 'ProgressSnackbar'}
        role="alert"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        {...other}
      >
        <Styled.Card variant="outlined">
          <NotificationDetail
            body={message}
            badgeInfo={notificationBadgeInfoMap.PROCESSING}
            icon={icon || 'questionMark'}
            title={title || ''}
            notificationKey={id}
            progressbar={
              <LinearProgress
                sx={{ width: '100%' }}
                variant="determinate"
                value={Math.min(100, Math.max(0, progressValue))}
              />
            }
          />
        </Styled.Card>
      </Styled.Wrapper>
    );
  }
);

ProgressSnackbarContent.displayName = 'ProgressSnackbarContent';
